import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { BrandKitProvider } from './brand/BrandKitContext.tsx'
import { ThemeProvider } from './theme/ThemeContext.tsx'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <BrandKitProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </BrandKitProvider>
    </ThemeProvider>
  </StrictMode>,
)
